var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderstand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.31,95s4.31-3.06,4.33-6.84v-57H106.87v2.73h-5.43V95Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75,92.42s4.31-3.06,4.33-6.84v-57H104.32v2.73h-7V92.42Z",
    fill: "#26404d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.01 31.35 146.01 23.02 126.64 23.02 126.64 31.35 97.36 31.35 97.36 92.42 175.1 92.42 175.1 31.35 146.01 31.35",
    fill: "#ccefff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5,49.62,142.34,48c-9.58-5.57-16.54,5.42-9.48,9.8L140,61.7c9.28,5,2.94,16.55-7.73,12.27l-4.64-2.28m9.17,9.56V74.9m0-34.75v6.32",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.27,31.18H15.51v2.73H10.08V95H86.94s4.31-3.06,4.33-6.84Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.71,28.62H13v2.73H6V92.42H84.39s4.31-3.06,4.33-6.84Z",
    fill: "#26404d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.9 31.35 37.9 23.02 18.52 23.02 18.52 31.35 6 31.35 6 92.42 83.74 92.42 83.74 31.35 37.9 31.35",
    fill: "#e6f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.48,50.5a7.14,7.14,0,0,1-7.41,6.84,7.14,7.14,0,0,1-7.41-6.84,7.14,7.14,0,0,1,7.41-6.84A7.14,7.14,0,0,1,43.48,50.5Zm12.3,13.63A6.86,6.86,0,1,0,63.19,71,7.14,7.14,0,0,0,55.78,64.13Zm-23,11,26.9-29.39",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269.67,95S274,91.92,274,88.14v-57H200.22v2.73h-7.41V95Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.11,92.42s4.31-3.06,4.33-6.84v-57H197.66v2.73h-8.93V92.42Z",
    fill: "#26404d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.18 31.35 257.18 23.02 237.8 23.02 237.8 31.35 188.73 31.35 188.73 92.42 266.47 92.42 266.47 31.35 257.18 31.35",
    fill: "#b3e7ff"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "222.72 45.91 222.72 55.85 211.95 55.85 211.95 67.71 222.72 67.71 222.72 77.65 235.57 77.65 235.57 67.71 246.34 67.71 246.34 55.85 235.57 55.85 235.57 45.91 228.34 45.91",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    opacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderstand);
export default __webpack_public_path__ + "static/media/understand.69ddef99.svg";
export { ForwardRef as ReactComponent };